import React, { useState, useEffect } from "react";
import { Spinner, MrSelect } from "mr_react_framework";
import { useSelector } from "react-redux";
import {
  appRegionSelector,
  currentUserSelector,
} from "views/Auth/Login/selector";
import { checkMob } from "lib/utils/helperMethods";
import { Col, Row, Tabs } from "antd";
import { actions as experienceActions } from "views/Experiences/redux";
import ExperienceAnalyticsSummary from "./ExperienceAnalyticsSummary";
import ExperienceAnalyticsQuestions from "./ExperienceAnalyticsQuestions";
import { activeAdjustedExperienceSelector } from "views/Experiences/selector";
import ExperienceAnalyticsTags from "./ExperienceAnalyticsTags";
import { useTranslate } from "lib/MrTranslate/MrTranslate";


const ExperienceAnalytics = (props) => {
  console.log("ExperienceAnalytics props ==>", props);
  // const {  } = props;
  const currentUser = useSelector(currentUserSelector());
  const activeExperience = useSelector(activeAdjustedExperienceSelector());
  const mrIntl = useTranslate()
  useEffect(() => {

    return () => {
    };
  }, []);

 
  return (
    <React.Fragment>
      {/* {isFirebaseTokenLoading && <Spinner />} */}
      <Row>
        <Col span={16} offset={4}>
          <Tabs defaultActiveKey="1" centered="true" className="custom-tabs-pills">
            <Tabs.TabPane tab={mrIntl("ExperienceAnalytics.summary")} key="1">
              <ExperienceAnalyticsSummary />
            </Tabs.TabPane>
            {activeExperience.settings["grading_setting"] === "per_question" && <Tabs.TabPane tab={mrIntl("ExperienceAnalytics.questions")} key="2">
              <ExperienceAnalyticsQuestions />
            </Tabs.TabPane>}
            {activeExperience.settings["grading_setting"] === "per_question" && <Tabs.TabPane tab={mrIntl("ExperienceAnalytics.standards")} key="3">
              <ExperienceAnalyticsTags />
            </Tabs.TabPane>}
          </Tabs>
            
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ExperienceAnalytics;
